import { allDomainNames, deployCountries } from "../contants";
import { DeployEnv, getDeployEnv } from "../utils";

// extract all domain from allDomainNames
const getAllBrandDomainNames = (deployCountries: string[]) => {
  const allBrandDomainNames = [];
  const availableCountries = deployCountries.map((country) => country.toUpperCase());
  for (const country in allDomainNames) {
    if (!availableCountries.includes(country.toUpperCase())) {
      continue;
    }
    for (const domainName in allDomainNames[country]) {
      allBrandDomainNames.push(allDomainNames[country][domainName]);
    }
  }
  return allBrandDomainNames;
};

export const baseURL = (() => {
  const currentEnv = getDeployEnv();
  const brandHostNames = getAllBrandDomainNames([deployCountries.TH, deployCountries.PH]);
  const hostname = window.location.hostname || "";
  if (hostname === "beta.ilovevip.com" || hostname === "beta-brand.ilovevip.com" || brandHostNames.includes(hostname)) {
    return "https://api.ilovevip.com";
  }

  if (currentEnv.deploymentType === DeployEnv.Production) {
    return "https://api.ilovevip.com";
  } else if (currentEnv.deploymentType === DeployEnv.Staging) {
    return "https://staging-api.ilovevip.com";
  }
  return process.env.REACT_APP_BASE_URL;
})();
